<template>
    <p>
        <router-link :to="{ name: 'Stats' }">
            &laquo; Usage statistics
        </router-link>
    </p>
</template>
